const RFNSearch = (() => {
  const parts = new Set('controller motor battery charger chain sprocket brake lever pad disc rotor throttle grip tire tyre tube wheel rim spoke bearing fork shock suspension handlebar seat fender cable wiring harness switch display sensor cover guard pedal spring axle bolt nut washer tensioner kickstand stand gasket seal kit assembly left right front rear master cylinder'.split(' '));
  const aliases = { batteries: 'battery', tyres: 'tyre', tires: 'tire', controllers: 'controller', motors: 'motor', chargers: 'charger', chains: 'chain', sprockets: 'sprocket', brakes: 'brake', levers: 'lever', pads: 'pad', discs: 'disc', rotors: 'rotor', grips: 'grip', tubes: 'tube', wheels: 'wheel', bearings: 'bearing', forks: 'fork', shocks: 'shock', handlebars: 'handlebar', seats: 'seat', fenders: 'fender', cables: 'cable', covers: 'cover', springs: 'spring', kits: 'kit' };
  const filler = new Set('for my the a an i need looking find me please on rfn warrior kids replacement oem part parts of want buy get'.split(' '));
  function query(raw) {
    const text = raw.trim();
    if (/[:"()]/.test(text) || /\b(?:not|or)\b/i.test(text)) return text;
    const modelPattern = /\b(?:(?:sx[\s-]*)?e[\s-]*(350|500|800|15|8|5)(?:[\s-]*(plus)|\s*(\+))?|(?:evo|zip)[\s-]*(16|18|20|24))\b\+?/gi;
    const matches = [...text.matchAll(modelPattern)];
    if (matches.length !== 1) return text;
    const match = matches[0];
    const model = match[1] ? `SX-E${match[1]}${match[2] || match[3] || match[0].endsWith('+') ? ' Plus' : ''}` : `${/^evo/i.test(match[0]) ? 'EVO' : 'ZIP'} ${match[4]}`;
    const rest = (text.slice(0, match.index) + ' ' + text.slice(match.index + match[0].length)).toLowerCase().replace(/[?!.,]/g, ' ').trim();
    const tokens = rest.split(/\s+/).filter(Boolean).filter(word => !filler.has(word)).map(word => aliases[word] || word);
    if (!tokens.length || tokens.some(word => !parts.has(word))) return text;
    return `title:"${model}" ${[...new Set(tokens)].map(word => `title:${word}`).join(' ')}`;
  }
  function parameters(params) {
    const next = new URLSearchParams(params);
    const raw = next.get('q');
    if (!raw) return next;
    const parsed = query(raw);
    next.set('q', parsed);
    if (parsed !== raw) next.set('type', 'product');
    if (next.get('options[unavailable_products]') !== 'hide') next.set('options[unavailable_products]', 'show');
    return next;
  }
  function rank(list, titleSelector, raw) {
    const parsed = query(raw);
    if (!parsed.startsWith('title:"')) return;
    const wanted = [...parsed.matchAll(/title:([a-z]+)/g)].map(match => match[1]);
    if (!wanted.length) return;
    const score = node => {
      const title = node.querySelector(titleSelector)?.textContent || '';
      const words = title.toLowerCase().replace(/\b(?:sx[\s-]*)?e[\s-]*\d+(?:\s*plus)?\b|\b(?:evo|zip)\s*\d+\b/g, ' ').match(/[a-z]+/g) || [];
      return words.reduce((total, word) => {
        const token = aliases[word] || word;
        if (wanted.includes(token) || filler.has(token) || ['factory', 'pro', 'sold', 'out', 'plus', 'and', 'left', 'right', 'front', 'rear'].includes(token)) return total;
        return total + (parts.has(token) ? 10 : 1);
      }, 0);
    };
    const original = [...list.children];
    const sorted = original.map((node, index) => ({ node, index, score: score(node) })).sort((a, b) => a.score - b.score || a.index - b.index);
    if (sorted.some((item, index) => item.node !== original[index])) sorted.forEach(item => list.append(item.node));
  }
  return { query, parameters, rank };
})();

window.RFNSearch = RFNSearch;
document.addEventListener('submit', event => {
  const form = event.target;
  if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !form.querySelector('input[name="q"][type="search"]')) return;
  const url = new URL(form.action, window.location.href);
  if (url.origin !== window.location.origin || !/\/search\/?$/.test(url.pathname)) return;
  event.preventDefault();
  url.search = RFNSearch.parameters(new URLSearchParams(new FormData(form))).toString();
  window.location.assign(url.href);
});
if (/\/search\/?$/.test(window.location.pathname) && !window.Shopify?.designMode) {
  const url = new URL(window.location.href);
  if (url.searchParams.get('q')?.startsWith('title:"')) document.title = document.title.replaceAll('title:', '').replaceAll('"', '');
  const next = RFNSearch.parameters(url.searchParams);
  if (next.toString() !== url.searchParams.toString()) {
    url.search = next.toString();
    window.location.replace(url.href);
  }
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

const rfnSearchGrid = document.querySelector('.template-search #ProductGridContainer');
if (rfnSearchGrid) {
  const rankResults = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('sort_by') && params.get('sort_by') !== 'relevance') return;
    const list = rfnSearchGrid.querySelector('#product-grid > ul.product-grid');
    if (list) RFNSearch.rank(list, 'a[id^="CardLink"]', params.get('q') || '');
  };
  rankResults();
  new MutationObserver(rankResults).observe(rfnSearchGrid, { childList: true, subtree: true });
}
